import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { UiAdminModule } from '@eiq/ui';

import { StimulusComponent } from './components/stimulus/stimulus/stimulus.component';
import { StimulusPreviewDialogComponent } from './components/stimulus/stimulus-preview/stimulus-preview-dialog.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, MatButtonModule, MatDialogModule, UiAdminModule],
  declarations: [StimulusComponent, StimulusPreviewDialogComponent],
  exports: [StimulusComponent]
})
export class SurveySharedModule {}
